module.exports = __webpack_public_path__ + "img/1-32-7.3a15465a.png";